<div class="container">
    <div class="my-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="APP_ROUTES.INDEX">{{ NAVS.INDEX }}</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{ NAVS.ERROR.INDEX }}</li>
            </ol>
        </nav>
    </div>


    <img src="/assets/404.svg" alt="404" class="d-block mx-auto mw-100 mh-50vh">
</div>

